
const UIkit = (window as any).UIkit;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { GiftshopProduct, GiftshopVariant } from '@/models/Giftshop';
import { ProductResourceImage } from '@/models/Product';

@Component({
    name: 'GiftshopSelectionModalProductImages',
    components: {
    }
})
export default class GiftshopSelectionModalProductImages extends Vue {
    @Prop({ type: Object, required: true }) product: GiftshopProduct;
    @Prop({ type: Object, required: false }) selectedVariant: GiftshopVariant;
    @Prop({ type: String, required: false }) selectedDimension1: string;
    
    private activeImage: ProductResourceImage = null;
    private showVideo: boolean = false;
    private lightboxId: string = 'product-images-lightbox';
    
    get isMobile() {
        return this.$screen.breakpoint === 'mobile';
    }
    
    get isMobileReady() {
        return this.isMobile;
    }
    
    get showAsSlider() {
        return this.isMobile && this.showMediaBrowser;
    }
    
    get images(): ProductResourceImage[] {
        
        /*
        - Use current product by default
        - If variants are active
        - Use parent product by default (IF WE ALWAYS REDIRECT TO PARENT IN THE CONTROLLER, THIS WONT BE NECESSARY!)
        - If a variant dimension is selected, add dimension images to the front
        - If a variant is selected, add variant images to the front
        */
        
        const variantImages = this.selectedVariant?.images ?? [];
        const dimensionImages = this.product?.dimension1images[this.selectedDimension1?.toLowerCase()] ?? [];
        const productImages = variantImages.length || dimensionImages.length ? [] : this.product?.images ?? [];
        
        return [...new Set([
        ...variantImages,
        ...dimensionImages,
        ...productImages,
        ])];
    }
    
    get fallbackImage(): string {
        return this.product?.images?.[0]?.url;
    }
    
    get hasVideo(): boolean {
        return this.videoIframeUrl != null;
    }
    get showMediaBrowser(): boolean {
        return this.hasVideo ? this.imageCount > 0 : this.imageCount > 1;
    }
    
    get mainImage(): ProductResourceImage {
        return this.images?.[0];
    }
    
    get imageCount(): number {
        return this.images?.length ?? 0;
    }
    
    get activeImageIndex(): number {
        return this.images?.map(i => i.url)?.indexOf(this.activeImage?.url) ?? -1;
    }
    
    get productName(): string {
        return this.product?.name;
    }
    
    get videoMediaType(): string {
        const url = this.product?.video ?? "";
        if (!url.length)
            return null;

        if (url.indexOf("youtu.be") != -1 || url.indexOf("youtube.") != -1) return "youtube";
        else if (url.indexOf("vimeo.") != -1) return "vimeo";
        
        return null;
    }
    
    get videoMediaId(): string {
        const url = this.product?.video ?? "";
        if (!url.length)
            return null;

        var mediaid = url;
        
        if (this.videoMediaType === "youtube" && mediaid.indexOf("watch?") >= 0)
        {
            mediaid = mediaid.split("v=")[1];
            
            if (mediaid.indexOf("&") >= 0) mediaid = mediaid.split("&")[0];
        }
        
        if (mediaid.indexOf("?") >= 0) mediaid = mediaid.split("?")[0];
        
        if (mediaid.indexOf("/") >= 0) mediaid = mediaid.split("/").slice(-1)[0];
        
        return mediaid != url ? mediaid : null;
    }

    get videoIframeUrl(): string {
        const url = this.product?.video ?? "";
        if (!url.length || !this.videoMediaId)
            return null;

        if (this.videoMediaType == "youtube") {
            return `https://www.youtube-nocookie.com/embed/${this.videoMediaId}?autoplay=0&showinfo=0&rel=0&modestbranding=0&playsinline=1&loop=0&controls=0&disablekb=1`;
        }
        else if (this.videoMediaType == "vimeo") { 
            return `https://player.vimeo.com/video/${this.videoMediaId}?byline=0&portrait=0&title=1&true&loop=0&autoplay=1&mute=0&responsive=1`;
        }

        return null;
    }

    toggleVideo() {
        this.showVideo = !this.showVideo;
    }

    private getSizeUrl(img: ProductResourceImage, size: string = 'large') {
        return img?.variants[size] ?? img?.url;
    }
    
    private setActiveImage(img: ProductResourceImage) {
        this.activeImage = img;
    }
    
    private toggleLightbox() {
        UIkit.lightbox(`#${this.lightboxId}`).show(this.activeImageIndex);
    }
        
    @Watch('images', {immediate: true})
    private onImagesChange() {
        this.setActiveImage(this.mainImage);
    }
}
